import React, { useState, useEffect, use } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Calendar, ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import { Footer } from "../components/Footer";
import { CompactHeader } from "../components/CompactHeader";
import * as Constants from "../../constants";
import BackLoader from "../../components/backloader";

export default function NewsSingle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [news, setNews] = useState(null);
  const [html, setHtml] = useState("");

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    onLoadNews();
  }, [id]);
  const onLoadNews = async () => {
    try {
      setLoading(true);
      const resp = await fetch(`${Constants.apiUrl}/cms/news/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        setNews(data.item);
        setHtml(Constants.b64decode(data.item.fullNote));
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  if (!news) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 text-gray-700 dark:text-gray-300">
        <p>News article not found.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      <CompactHeader />
      {/* HERO SECTION */}
      <section className="relative py-12 bg-hero-light-image dark:bg-hero-dark">
        <div className="absolute inset-0 bg-black/10 dark:bg-black/30"></div>
        <div className="container mx-auto px-4 text-center relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold mb-3 text-gray-900 dark:text-white">
            {news?.title}
          </h1>
          <p className="text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">
            Category: {news?.newsType} &nbsp;|&nbsp;{" "}
            {new Date(news?.newsOn).toLocaleDateString()}
          </p>
        </div>
      </section>

      {/* MAIN ARTICLE */}
      <section className="py-12">
        <div className="container mx-auto max-w-5xl px-4">
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 p-8">
            <button
              onClick={() => navigate(-1)}
              className="inline-flex items-center mb-6 text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 transition"
            >
              <ArrowLeft className="w-4 h-4 mr-2" /> Back to News
            </button>

            {news.thumbnail && (
              <img
                src={`${Constants.docUrl}/cms/news/${news.coverImage}`}
                alt={news.title}
                className="w-full h-80 object-cover rounded-xl mb-8"
              />
            )}

            <div className="flex items-center text-sm text-gray-500 dark:text-gray-400 mb-4">
              <Calendar className="w-4 h-4 mr-1" />
              {new Date(news.newsOn).toLocaleDateString()}
            </div>

            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              {news.title}
            </h2>

            <div className="space-y-5 text-gray-700 dark:text-gray-300 leading-relaxed">
              <div
                className="htmlwrap"
                dangerouslySetInnerHTML={{ __html: html }}
              ></div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <BackLoader open={loading} />
    </div>
  );
}
